import { useLocalStorage } from './useLocalStorage';
import { INDICATORS } from '@/lib/indicators';

export type Weights = Record<string, number>;

const defaultWeights: Weights = Object.fromEntries(
  INDICATORS.map((i) => [i.id, i.weight]),
);

/**
 * Admin-configurable scoring weights. Currently informational overrides that
 * persist locally; the engine reads the indicator defaults, and these are
 * surfaced in the admin panel so weights can be tuned.
 */
export function useScoringWeights() {
  const [weights, setWeights] = useLocalStorage<Weights>(
    'bchliq:weights',
    defaultWeights,
  );

  const setWeight = (id: string, value: number) => {
    setWeights({ ...weights, [id]: value });
  };

  const reset = () => setWeights(defaultWeights);

  return { weights, setWeight, reset, defaultWeights };
}
